import { render, staticRenderFns } from "./UGradingSmiles.vue?vue&type=template&id=c92e2284&scoped=true&"
import script from "./UGradingSmiles.vue?vue&type=script&lang=js&"
export * from "./UGradingSmiles.vue?vue&type=script&lang=js&"
import style0 from "./UGradingSmiles.vue?vue&type=style&index=0&id=c92e2284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92e2284",
  null
  
)

export default component.exports